import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import _ from 'lodash'

import { useInputState } from '@/hooks/inputStateContext'
import { useMerchant } from '@/hooks/merchantContext'
import CollapsibleList from '@/components/CollapsibleList'
import SettingControl from '../SettingControl'
import config from '@/config'

const REACT_APP_REGION = process.env.REACT_APP_REGION || 'hk'

const getSettings = (isRabbitPayKeySet, isMerchantTH = false, isMerchantTW = false) => [
  ...(
    isMerchantTW
      ? [{
          label: '外賣自取現金支付功能',
          paramaterName: 'takeawayCashPayment',
          type: 'switch',
        }]
      : []
  ),
  {
    label: '外賣自取信用卡支付功能',
    paramaterName: 'takeawayCreditCardPayment',
    type: 'switch',
  },
  {
    label: '信用卡免驗證',
    paramaterName: 'skipCreditCardVerification',
    type: 'switch',
  },
  { label: '微信支付', paramaterName: 'enableWechatPay', type: 'switch' },
  { label: '支付寶', paramaterName: 'enableAliPay', type: 'switch' },
  { label: 'FPS', paramaterName: 'enableFps', type: 'switch' },
  { label: 'PayMe', paramaterName: 'enablePayMe', type: 'switch' },
  {
    label: 'Octopus Online',
    paramaterName: 'enableOctopusOnline',
    type: 'switch',
  },
  ...(
    isMerchantTH
      ? [
          {
            label: 'Rabbit Gateway',
            paramaterName: 'enableRabbitPay',
            type: 'switch',
            disabled: !isRabbitPayKeySet,
            inputProps: {
              disabled: !isRabbitPayKeySet,
              title: !isRabbitPayKeySet ? 'RabbitPay API key not set' : '',
            },
          },
        ]
      : []),
  ...(isMerchantTH
    ? [
        {
          label: 'Rabbit Rewards (Hook Coin)',
          paramaterName: 'enableRabbitRewards',
          type: 'switch',
        },
      ]
    : []),
  ...(config.environment !== 'production'
    ? [{ label: 'ByPass', paramaterName: 'enableByPass', type: 'switch' }]
    : []),
  { type: 'dimPaySelect' },
  {
    label: '堂食客人只限 App 付款',
    paramaterName: 'dineInPayOnAppOnly',
    type: 'switch',
  },
  {
    label: '堂食信用卡付款',
    paramaterName: 'enableDineInCreditCardPayment',
    type: 'switch',
  },
  {
    label: '堂食信用卡付款最低消費',
    paramaterName: 'dineInCreditCardPaymentMinCharge',
    type: 'input',
    inputOption: { type: 'number', min: 0 },
  },
  {
    label: '堂食微信支付',
    paramaterName: 'enableDineInWechatPay',
    type: 'switch',
  },
  { label: '堂食支付寶', paramaterName: 'enableDineInAliPay', type: 'switch' },
  { label: '堂食 FPS', paramaterName: 'enableDineInFps', type: 'switch' },
  { label: '堂食 PayMe', paramaterName: 'enableDineInPayMe', type: 'switch' },
  {
    label: '堂食 Octopus Online',
    paramaterName: 'enableDineInOctopusOnline',
    type: 'switch',
  },
  ...(REACT_APP_REGION === 'hk'
    ? []
    : [
        {
          label: '堂食 Rabbit Gateway',
          paramaterName: 'enableDineInRabbitPay',
          type: 'switch',
          disabled: !isRabbitPayKeySet,
          inputProps: {
            disabled: !isRabbitPayKeySet,
            title: !isRabbitPayKeySet ? 'RabbitPay API key not set' : '',
          },
        },
      ]
  ),
  ...(config.environment !== 'production'
    ? [
        {
          label: '堂食 ByPass',
          paramaterName: 'enableDineInByPass',
          type: 'switch',
        },
      ]
    : []),
]

const DIM_PAY_OPTIONS = [
  { value: 'off', label: '關閉DimPay' },
  { value: 'button', label: '打開DimPay (顯示付款按鈕)' },
  { value: 'qrcode', label: '打開DimPay (列印付款QRCode)' },
]

function getDimPayValue (inputState) {
  const enableDineInCustomerPay = _.get(inputState, 'enableDineInCustomerPay', false)
  const printPayQrOnReceipt = _.get(inputState, 'printPayQrOnReceipt', false)
  if (!enableDineInCustomerPay) return 'off'
  if (printPayQrOnReceipt) return 'qrcode'
  return 'button'
}

function DimPaySelect () {
  const [inputState, updateInputState] = useInputState()
  const [merchantState] = useMerchant()
  const classes = useDimPayStyles()
  const value = getDimPayValue(inputState)
  const isMerchantHK = merchantState.merchant?.region?.toUpperCase() === 'HK'
  const options = DIM_PAY_OPTIONS.filter(option => option.value !== 'qrcode' || isMerchantHK)

  const handleChange = (e) => {
    const selected = e.target.value
    switch (selected) {
      case 'off':
        updateInputState('enableDineInCustomerPay', false)
        updateInputState('printPayQrOnReceipt', false)
        break
      case 'button':
        updateInputState('enableDineInCustomerPay', true)
        updateInputState('printPayQrOnReceipt', false)
        break
      case 'qrcode':
        updateInputState('enableDineInCustomerPay', true)
        updateInputState('printPayQrOnReceipt', true)
        break
    }
  }

  return (
    <FormControl
      variant='outlined' margin='dense' fullWidth
      classes={{ root: classes.container }}
    >
      <InputLabel margin='dense'>DimPay(堂食客人付款)</InputLabel>
      <Select
        label='DimPay(堂食客人付款)'
        variant='outlined'
        fullWidth
        value={value}
        onChange={handleChange}
      >
        {options.map(item => (
          <MenuItem value={item.value} key={item.value}>{item.label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

const useDimPayStyles = makeStyles(theme => ({
  container: {
    background: 'white !important',
  },
}))

/**
 *
 * @param {*} props
 * @returns
 */
export default function PaymentSettings (props) {
  const [expand, setExpand] = React.useState(false)
  const [merchantState] = useMerchant()
  const isRabbitPayKeySet = merchantState.merchant?.setting?.isRabbitPayKeySet ?? false
  const isMerchantTH = merchantState.merchant?.region?.toUpperCase() === 'TH'
  const isMerchantTW = merchantState.merchant?.region?.toUpperCase() === 'TW'
  const SETTINGS = getSettings(isRabbitPayKeySet, isMerchantTH, isMerchantTW)

  return (
    <CollapsibleList title='付款方式設定' expand={expand} setExpand={setExpand}>
      {SETTINGS.map((setting) => {
        if (setting.type === 'dimPaySelect') {
          return <DimPaySelect key='dimPaySelect' />
        }
        return <SettingControl key={setting.label} setting={setting} />
      })}
    </CollapsibleList>
  )
}
